var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var filterObjectById = function (state, id) {
    var newState = __assign({}, state);
    newState[id] = undefined;
    return newState;
};
var getBlocksByPosition = function (stateBlocks, newBlocks, reverse) {
    var blocks = __spreadArray([], stateBlocks, true);
    var result = [];
    newBlocks === null || newBlocks === void 0 ? void 0 : newBlocks.forEach(function (block) {
        result = __spreadArray(__spreadArray(__spreadArray([], blocks.slice(0, block === null || block === void 0 ? void 0 : block.position), true), [
            block
        ], false), blocks.slice(block === null || block === void 0 ? void 0 : block.position), true);
    });
    if (reverse) {
        result = __spreadArray(__spreadArray([], newBlocks, true), stateBlocks, true);
    }
    return result;
};
export var updateObjectById = function (state, id, newObject, initialData) {
    var newState = __assign({}, state);
    if (newState[id])
        newState[id] = __assign(__assign({}, (newState[id] || [])), newObject);
    else
        newState[id] = __assign(__assign({}, initialData), newObject);
    return newState;
};
export var changeInAllObjects = function (state, newObject) {
    var newState = __assign({}, state);
    for (var key in newState) {
        newState[key] = __assign(__assign({}, newState[key]), newObject);
    }
    return newState;
};
export var updateObjectByIdAndAddBlocks = function (state, id, blocks, newObject, reverseParam) {
    var _a;
    var newState = __assign({}, state);
    newState[id] = __assign(__assign({}, (newState[id] || [])), __assign({ blocks: getBlocksByPosition((_a = newState[id]) === null || _a === void 0 ? void 0 : _a.blocks, blocks, reverseParam) }, newObject));
    return newState;
};
export var updateObjectByIdAndFilterBlocks = function (state, id, position, newObject) {
    var _a, _b;
    var newState = __assign({}, state);
    newState[id] = __assign(__assign({}, (newState[id] || [])), __assign({ blocks: __spreadArray([], (((_b = (_a = newState[id]) === null || _a === void 0 ? void 0 : _a.blocks) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return position != item.position; })) || []), true) }, newObject));
    return newState;
};
//# sourceMappingURL=newReducerHelpers.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var filterObjectById = function (state, id) {
    var newState = __assign({}, state);
    newState[id] = undefined;
    return newState;
};
var getBlocksByPosition = function (stateBlocks, newBlocks, reverse) {
    var blocks = __spreadArray([], stateBlocks, true);
    var result = [];
    newBlocks === null || newBlocks === void 0 ? void 0 : newBlocks.forEach(function (block) {
        result = __spreadArray(__spreadArray(__spreadArray([], blocks.slice(0, block === null || block === void 0 ? void 0 : block.position), true), [
            block
        ], false), blocks.slice(block === null || block === void 0 ? void 0 : block.position), true);
    });
    if (reverse) {
        result = __spreadArray(__spreadArray([], newBlocks, true), stateBlocks, true);
    }
    return result;
};
export var updateObjectById = function (state, id, newObject, initialData) {
    var newState = __assign({}, state);
    if (newState[id])
        newState[id] = __assign(__assign({}, (newState[id] || [])), newObject);
    else
        newState[id] = __assign(__assign({}, initialData), newObject);
    return newState;
};
export var changeInAllObjects = function (state, newObject) {
    var newState = __assign({}, state);
    for (var key in newState) {
        newState[key] = __assign(__assign({}, newState[key]), newObject);
    }
    return newState;
};
export var updateObjectByIdAndAddBlocks = function (state, id, blocks, newObject, reverseParam) {
    var _a;
    var newState = __assign({}, state);
    newState[id] = __assign(__assign({}, (newState[id] || [])), __assign({ blocks: getBlocksByPosition((_a = newState[id]) === null || _a === void 0 ? void 0 : _a.blocks, blocks, reverseParam) }, newObject));
    return newState;
};
export var updateObjectByIdAndFilterBlocks = function (state, id, position, newObject) {
    var _a, _b;
    var newState = __assign({}, state);
    newState[id] = __assign(__assign({}, (newState[id] || [])), __assign({ blocks: __spreadArray([], (((_b = (_a = newState[id]) === null || _a === void 0 ? void 0 : _a.blocks) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return position != item.position; })) || []), true) }, newObject));
    return newState;
};
//# sourceMappingURL=newReducerHelpers.js.map